import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { Review } from '../../entities/Review';
import { Pagination } from '../../features/Pagination/index.js';
import { toast, ToastContainer } from 'react-toastify';
import { PageBar } from '../../shared/ui/PageBar';

const ReviewsPage = () => {
  const [reviews, setReviews] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const [searchParams, setSearchParams] = useSearchParams();
  const isModeration = searchParams.get('type');

  const getData = (count = 10, offset = 0) => {
    apiRequests.reviews.get(count, offset).then((res) => setReviews(res));
  };

  const getDataFiltered = (count = 5, offset = 0) => {
    apiRequests.reviews
      .getWithFilters(undefined, true, count, offset)
      .then((res) => setReviews(res));
  };

  useEffect(() => {
    if (isModeration) {
      getDataFiltered();
    } else {
      getData();
    }
  }, [isModeration]);

  const handleDelete = async (id) => {
    const query = apiRequests.reviews.delete(id).then(() =>
      setReviews((prev) => ({
        totalCount: prev.totalCount,
        items: prev.items.filter((i) => i.id !== id),
      })),
    );
    toast.promise(query, {
      pending: 'Идёт запрос...',
      error: 'Произошла ошибка',
      success: 'Отзыв успешно удалён',
    });
  };

  const handleVisible = async (id, value) => {
    await apiRequests.reviews.hide(id, value).then(() =>
      setReviews((prev) => {
        const arr = prev.items.map((i) => {
          if (i.id !== id) {
            return i;
          } else {
            return {
              ...i,
              isHidden: value,
            };
          }
        });
        return { totalCount: prev.totalCount, items: arr };
      }),
    );
  };

  const handleSearch = () => {
    apiRequests.reviews.getWithFilters(searchValue).then((res) => setReviews(res));
  };

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск отзывов..."
      />

      <nav className="nav at-nav nav-pills flex-column flex-sm-row mb-3">
        <button
          onClick={() => setSearchParams((prev) => ({ ...prev, type: 'moderation' }))}
          className={`flex-sm-fill text-sm-center nav-link ${isModeration && 'active'}`}
        >
          Ожидают модерации
        </button>
        <button
          onClick={() => setSearchParams(() => ({}))}
          className={`flex-sm-fill text-sm-center nav-link ${!isModeration && 'active'}`}
          aria-current="page"
        >
          Все отзывы
        </button>
      </nav>

      <div className="page-table mb-3">
        {reviews.items?.length === 0 ? (
          <p className={'text-center'}>По вашему запросу ничего не найдено</p>
        ) : (
          reviews.items?.map((i) => (
            <Review onChangeVisible={handleVisible} onDelete={handleDelete} key={i.id} data={i} />
          ))
        )}
      </div>

      <Pagination
        count={reviews.totalCount}
        itemsPerPage={10}
        onChange={(page) => getData(10, 10 * page)}
      />
      <ToastContainer />
    </>
  );
};

export default ReviewsPage;
